import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from "@mui/material";
import { useCallback, useEffect } from "react";
import { ModalLoading } from "../../../../../../common/components/modal_loading";
import { ModalContainer } from "../../../../../../common/components/modal_container";

import { ManutencaoEquipObraForm, ManutencaoEquipObraSchema } from "../../../schemas/Obras_maquinasequipamentos/Obras_maquinasequipamentos";
import { zodResolver } from "@hookform/resolvers/zod";
import { useForm } from "react-hook-form";
import DefaultFormInput from "../../../../../../common/components/default_form_input";
import { FormDatePickerInput } from "../../../../../../common/components/masked_inputs/react_forms/form_date_picker_input";
import PrimaryButton from "../../../../../../common/components/primary_button";
import { DropDownFornecedor } from "../../../../../../common/components/dropdown_fornecedor";
import { ManutencaoEquipObra } from "../../../../domain/models/manutencao_equip_obra";

type Props = {
  open: boolean;
  saving: boolean;
  selectedManutencaoEquipObra?: ManutencaoEquipObra | null;

  onClose: () => void;
  onSubmit: (form: ManutencaoEquipObraForm) => void;
};

export const ModalCreateObrasMaquinasEquipamentos = ({
  open,
  saving,
  selectedManutencaoEquipObra,

  onClose,
  onSubmit,
}: Props) => {

  const hookForm = useForm<ManutencaoEquipObraForm>({
    mode: "onSubmit",
    reValidateMode: "onSubmit",
    resolver: zodResolver(ManutencaoEquipObraSchema),

  });

  const [status] = hookForm.watch(["status"]);

  useEffect(() => {
    if (selectedManutencaoEquipObra) {
      hookForm.setValue("idManutencaoEquipObra", selectedManutencaoEquipObra.idManutencaoEquipObra ?? null);
      hookForm.setValue("idObra", selectedManutencaoEquipObra.idObra ?? null);
      hookForm.setValue("status", selectedManutencaoEquipObra.status ?? false);
      hookForm.setValue("descricao", selectedManutencaoEquipObra.descricao ?? "");
      hookForm.setValue("dataPrevDevolucao", selectedManutencaoEquipObra.dataPrevDevolucao ?? null);
      hookForm.setValue("dataManutencao", selectedManutencaoEquipObra.dataManutencao ?? null);
      hookForm.setValue("dataProxManutencao", selectedManutencaoEquipObra.dataProxManutencao ?? null);
      hookForm.setValue("dataDevolucao", selectedManutencaoEquipObra.dataDevolucao ?? null);
      hookForm.setValue("statusDevolucao", selectedManutencaoEquipObra.statusDevolucao ?? false);
      hookForm.setValue("idFornecedor", selectedManutencaoEquipObra.idFornecedor ?? null);
      hookForm.setValue("parteEletrica", selectedManutencaoEquipObra.parteEletrica ?? "");
      hookForm.setValue("parteMecanica", selectedManutencaoEquipObra.parteMecanica ?? "");
      hookForm.setValue("lubrificacao", selectedManutencaoEquipObra.lubrificacao ?? "");
      hookForm.setValue("limpeza", selectedManutencaoEquipObra.limpeza ?? "");
      hookForm.setValue("outros1", selectedManutencaoEquipObra.outros1 ?? "");
      hookForm.setValue("outros2", selectedManutencaoEquipObra.outros2 ?? "");
      hookForm.setValue("observacao", selectedManutencaoEquipObra.observacao ?? "");
      hookForm.setValue("descLocatario", selectedManutencaoEquipObra.descLocatario ?? "");
    } else {
      hookForm.reset({
        status: false,
        statusDevolucao: false,
        idManutencaoEquipObra: undefined,
        idObra: undefined,
        descricao: "",
        dataManutencao: null,
        dataProxManutencao: null,
        parteEletrica: "",
        parteMecanica: "",
        lubrificacao: "",
        limpeza: "",
        observacao: "",
        outros1: "",
        outros2: "",
        delete: false,
        dataPrevDevolucao: null,
        idFornecedor: undefined,
        descLocatario: "",
        dataDevolucao: null,
      });
    }
  }, [
    selectedManutencaoEquipObra,
    hookForm
  ]);

  const handleClose = useCallback(() => {
    if (!saving) onClose();
  }, [saving, onClose]);

  const handleSubmit = useCallback((form: any) => {
    if (!saving) onSubmit(form);
  },
    [saving, onSubmit],
  );

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      slotProps={{
        paper: {
          component: "form",
          onSubmit: hookForm.handleSubmit(handleSubmit),
        },
      }}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": { width: "100%", maxWidth: "90rem" },
        },
      }}
    >
      <DialogTitle>Cadastrar Manutenção</DialogTitle>
      <DialogContent>
        <ModalLoading loading={saving}>
          <ModalContainer>
            <Box gap={2} display="flex" flexDirection="column" width="100%">
              <FormLabel>Status do Equipamento</FormLabel>
              <FormControl size="small">
                <RadioGroup row value={hookForm.watch("status")} onChange={(e) => hookForm.setValue("status", e.target.value === "true")}>
                  <FormControlLabel value={false} control={<Radio />} label="Próprio" />
                  <FormControlLabel value={true} control={<Radio />} label="Alugado" />
                </RadioGroup>
              </FormControl>
              <Box display="grid" gridTemplateColumns="1fr 1fr" gap={3}>
                {/* Coluna 1 */}
                <Box display="flex" flexDirection="column" gap={2}>
                  <DefaultFormInput name="descricao" label="Equipamento" reactHookForm={hookForm} required />
                  {
                    status &&
                    <FormDatePickerInput name="dataPrevDevolucao" label="Data Prevista Devolução" reactHookForm={hookForm} />
                  }
                  <FormDatePickerInput name="dataManutencao" label="Data Vistoria" reactHookForm={hookForm} />
                  <FormDatePickerInput name="dataProxManutencao" label="Data Próxima Vistoria" reactHookForm={hookForm} />
                  {
                    status && (
                      <>
                        <FormDatePickerInput name="dataDevolucao" label="Data da Devolução" reactHookForm={hookForm} />
                        <FormControl size="small" fullWidth>
                          <FormLabel>Devolvido</FormLabel>
                          <RadioGroup
                            row
                            value={hookForm.watch("statusDevolucao") === true ? "true" : "false"}
                            onChange={(e) => hookForm.setValue("statusDevolucao", e.target.value === "true")}>
                            <FormControlLabel value="true" control={<Radio />} label="Sim" />
                            <FormControlLabel value="false" control={<Radio />} label="Não" />
                          </RadioGroup>
                        </FormControl>
                        <FormControl size="small" fullWidth>
                          <DropDownFornecedor name="idFornecedor" label="Fornecedor" reactHookForm={hookForm} />
                        </FormControl>
                      </>
                    )
                  }
                </Box>

                {/* Coluna 2 */}
                <Box display="flex" flexDirection="column" gap={2}>
                  <DefaultFormInput name="parteEletrica" label="Parte Elétrica" reactHookForm={hookForm} />
                  <DefaultFormInput name="parteMecanica" label="Parte Mecânica" reactHookForm={hookForm} />
                  <DefaultFormInput name="lubrificacao" label="Lubrificação" reactHookForm={hookForm} />
                  <DefaultFormInput name="limpeza" label="Limpeza" reactHookForm={hookForm} />
                  <DefaultFormInput name="outros1" label="Outros" reactHookForm={hookForm} />
                  <DefaultFormInput name="outros2" label="Outros" reactHookForm={hookForm} />
                </Box>
              </Box>

              <DefaultFormInput name="observacao" label="Observação" reactHookForm={hookForm} multiline rows={3} />
            </Box>
          </ModalContainer>
        </ModalLoading>
      </DialogContent>

      <DialogActions>
        <Box className="w-full flex justify-end gap-4 p-4">
          <Box className="flex gap-1">
            <Box className="p-2 hover:bg-hover-light-gray cursor-pointer dark:hover:bg-border-dark-gray rounded-[4px] font-semibold">
              <h1 className="text-sm text-black dark:text-white" onClick={handleClose}>
                Cancelar
              </h1>
            </Box>
            <Box width="120px">
              {saving ? (
                <PrimaryButton buttonColor="primary-green">{"Salvando..."}</PrimaryButton>
              ) : (
                <PrimaryButton type="submit" buttonColor="primary-green">
                  {"Salvar"}
                </PrimaryButton>
              )}
            </Box>
          </Box>
        </Box>
      </DialogActions>
    </Dialog>
  );
};
